export default __webpack_public_path__ + "static/media/setting-the-stage.bf5a1f27.png";